import React from "react";
import styled from "styled-components";
import Theme from "../../Theme/Theme";
import CustomDivider from "../../Utils/CustomDivider/CustomDivider";

function RequestResultStudent() {
  return (
    <Container>
      <TitleElement>
        <ImgContainer>
          <TitleIcon src="/Assets/Images/DocumentBlue.svg"></TitleIcon>
        </ImgContainer>
        <TitleText>نتیجه درخواست</TitleText>
      </TitleElement>
      <CustomDivider></CustomDivider>
      <BottomContainer>
        <CommentElement>
          <RequestTextContainer>
            <Titlerequest>متن درخواست:</Titlerequest>
            <TextBoxContainer>
              {""}
              با عرض سلام
              <br></br>
              من روز دوشنبه که انتخاب واحد انجام شد، دروس مهندسی اینترنت، پایگاه
              داده را با اساتید مربوطه برداشتم اما ظاهرا این دروس حذف شده!!!
              اسکرین شات های انتخاب واحد رو هم خدمتتون ارسال کردم.
              <br></br>
              با تشکر{" "}
            </TextBoxContainer>
          </RequestTextContainer>
          <RequestTextContainer>
            <Titlerequest>پاسخ مسئولین:</Titlerequest>
            {/* این بخش باید مپ بخوره تا هر متن رو نمایش بده */}
            <AnswerTextBoxContainer>
              <AnswerDetails>
                <NameContainerInAnswer>
                  <ImgAnswerContainer>
                    <ImgAnswer src=""></ImgAnswer>
                  </ImgAnswerContainer>
                  <NameDetails>
                    <Name>دکتر باقر رحیم پور کاوی</Name>
                    <Details>مدیر گروه کامپیوتر</Details>
                  </NameDetails>
                </NameContainerInAnswer>
              </AnswerDetails>
              <TextBoxContainerTransp></TextBoxContainerTransp>
            </AnswerTextBoxContainer>
            {/* ------------------------------------------ */}
          </RequestTextContainer>
        </CommentElement>
        <OtherElement>
          <FilesContainer>
            <FileTitle>فایل های ضمیمه:</FileTitle>
          </FilesContainer>
          <StatesContainer>
            <FileTitle>وضعیت درخواست شما:</FileTitle>
          </StatesContainer>
        </OtherElement>
      </BottomContainer>
    </Container>
  );
}

export default RequestResultStudent;

const Container = styled.div`
  width: 100%;
  height: 100%;
  background-color: transparent;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  direction: rtl;
  box-sizing: border-box;
  padding: 5px;
`;

const TitleElement = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  padding-inline: 20px;
`;

const ImgContainer = styled.div`
  width: 38px;
  height: 38px;
  border: 1px solid #f5f7f8;
  background-color: transparent;
  border-radius: ${Theme.borderRadius};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const TitleIcon = styled.img`
  object-fit: contain;
`;

const TitleText = styled.p`
  height: 40px;
  font-size: ${Theme.fontTitleSize};
  font-weight: ${Theme.fontInfoWeight};
  line-height: 41px;
  box-sizing: border-box;
  padding-inline: 20px;
`;

const BottomContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
`;

const CommentElement = styled.div`
  width: 50%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  padding-inline: 50px;
  padding-block: 20px;
`;

const OtherElement = styled.div`
  width: 50%;
  height: fit-content;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  box-sizing: border-box;
  padding-top: 30px;
`;

const RequestTextContainer = styled.div`
  width: 100%;
  height: fit-content;
  background-color: transparent;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 10px;
  box-sizing: border-box;
  padding-top: 5px;
`;

const Titlerequest = styled.div`
  font-size: ${Theme.fontTitleSize};
  font-weight: ${Theme.fontWeight};
  color: ${Theme.colorFontBlack};
  margin-bottom: 10px;
`;

const TextBoxContainer = styled.div`
  width: 100%;
  height: fit-content;
  min-height: 200px;
  background-color: ${Theme.colorBackgroundPage};
  border-radius: ${Theme.borderRadius};
  box-sizing: border-box;
  padding-inline: 15px;
  padding-block: 15px;
  direction: rtl;
  text-align: justify;
`;

const AnswerTextBoxContainer = styled.div`
  width: 100%;
  height: fit-content;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  border: 3px solid #e3e3e3;
  border-radius: ${Theme.borderRadius};
`;

const AnswerDetails = styled.div`
  width: 100%;
  height: 70px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding-inline: 15px;
`;

const NameContainerInAnswer = styled.div`
  width: fit-content;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
`;

const NameDetails = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  margin-right: 5px;
  box-sizing: border-box;
  padding-top: 20px;
`;

const Name = styled.p`
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  height: fit-content;
  font-size: ${Theme.fontSize};
  font-weight: ${Theme.fontWeight};
  color: ${Theme.colorFontBlack};
`;

const Details = styled.p`
  box-sizing: border-box;
  padding: 0;
  height: fit-content;
  font-size: 14px;
  font-weight: ${Theme.fontWeight};
  color: ${Theme.colorFontLabel};
`;

const ImgAnswerContainer = styled.div`
  width: 60px;
  height: 60px;
  border: 1px solid ${Theme.colorBluePrimary};
  border-radius: ${Theme.borderRadius};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ImgAnswer = styled.img`
  object-fit: contain;
  width: 55px;
  height: 55px;
  border-radius: ${Theme.borderRadius};
`;

const TextBoxContainerTransp = styled.div`
  width: 100%;
  height: fit-content;
  min-height: 120px;
  background-color: transparent;
  border-radius: ${Theme.borderRadius};
  box-sizing: border-box;
  padding-inline: 15px;
  padding-block: 15px;
  direction: rtl;
  text-align: justify;
`;

const FilesContainer = styled.div`
  width: 40%;
  height: 180px;
  border-radius: ${Theme.borderRadius};
  border: 2px solid #e3e3e3;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  box-sizing: border-box;
  padding-inline: 20px;
`;

const FileTitle = styled.p`
  font-size: ${Theme.fontSize};
  font-weight: ${Theme.fontWeight};
  color: ${Theme.colorFontLabel};
`;

const StatesContainer = styled.div`
  width: 40%;
  height: 180px;
  border-radius: ${Theme.borderRadius};
  border: 2px solid #e3e3e3;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  box-sizing: border-box;
  padding-inline: 20px;
`;
